import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=d607bc98&scoped=true"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d607bc98",
  null
  
)

export default component.exports